// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"TextAreaInput_inputContainer__F6bZt"};